import { useEffect } from 'react'

const bundlePattern = /\/assets\/index-[A-Za-z0-9_-]+\.js/
export function forceUpdate() {
  const url = new URL(window.location.href)
  url.searchParams.set('_v', String(Date.now()))
  window.location.replace(url.toString())
}
// A KDS never becomes idle like a kiosk. Notify staff; apply only when they choose.
export function useAutoUpdate() {
  useEffect(() => {
    const running = [...document.querySelectorAll<HTMLScriptElement>('script[src]')].map((script) => script.src.match(bundlePattern)?.[0]).find(Boolean)
    if (!running) return
    let cancelled = false
    const check = async () => {
      try {
        const response = await fetch(`/?_v=${Date.now()}`, { cache: 'no-store' })
        if (!response.ok) return
        const served = (await response.text()).match(bundlePattern)?.[0]
        if (!cancelled && served && served !== running) window.dispatchEvent(new CustomEvent('galley:update-available'))
      } catch {
        /* Retry on the next check. */
      }
    }
    const onVisible = () => {
      if (document.visibilityState === 'visible') check()
    }
    check()
    const timer = setInterval(check, 5 * 60_000)
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      cancelled = true
      clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])
}
